<app-dialog [show]="show" [size]="'md'" [position]="'center'" (close)="onCancel()" [showHeader]="showHeader">
  <div class="flex flex-col items-center justify-center min-h-[350px] w-full px-4 py-6 sm:px-6 md:px-8">
    <div class="flex flex-col items-center">
      <div class="flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 mb-4">
        <i class="pi pi-exclamation-triangle text-3xl text-gray-400"></i>
      </div>
      <h2 class="text-lg sm:text-xl font-semibold text-center mb-2">Delete Transaction</h2>
      <p class="text-center text-gray-700 mb-4">
        Are you sure you want to delete transaction with file number {{ fileNumber }}? This action cannot be undone.
      </p>

      <div class="flex items-start w-full bg-gray-100 mb-4">        
        <app-alert-message [type]="'info'" [bordered]="false">
          <p class="text-gray-600 text-sm font-normal leading-normal font-['Inter']">Deleting this transaction will remove all associated data.</p>
        </app-alert-message>
      </div>



      <div class="flex items-center w-full mb-6">
        <input id="confirm-delete" type="checkbox" class="mr-2 accent-black w-4 h-4" [checked]="confirmChecked"
          (change)="onCheckboxChange($event)" />
        <label for="confirm-delete" class="text-sm text-gray-700 select-none">
          I understand that this action is permanent and cannot be reversed
        </label>
      </div>
      <div class="flex justify-end w-full gap-2">
        <button type="button" (click)="onCancel()"
          class="h-10 w-24 rounded-lg bg-gray-100 hover:bg-gray-200 text-sm text-gray-700 transition-colors cursor-pointer">
          Cancel
        </button>
        <button type="button" (click)="onDelete()" [disabled]="!confirmChecked" [ngClass]="{
            'bg-black text-white hover:bg-gray-800 cursor-pointer': confirmChecked,
            'bg-gray-300 text-gray-400 cursor-not-allowed opacity-60': !confirmChecked
          }" class="h-10 w-40 rounded-lg text-sm transition-colors duration-200">
          Delete Transaction
        </button>
      </div>
    </div>
  </div>
</app-dialog>